// TODO: Ask in engineering review if the following can be used to refactor everywhere where objects are indexed.
import {ColumnType} from './enums';

export function getValueFromObjectWithStringIndexing(entry: any, ...args: string[]): any {
  if (args.length === 0) {
    return entry;
  }
  if (args.length === 1) {
    return entry[args[0]];
  }
  return getValueFromObjectWithStringIndexing(entry[args[0]], ...args.slice(1));
}
